/*
  aro-collection-sort-oos-last.js
  Moves fully-out-of-stock product cards to the end of the current collection
  page after render. Scope: `.template-collection` body class only — /search
  and all other templates are untouched.

  Per-page reorder only: this does NOT span pagination boundaries. If a
  collection has more OOS products than fit on one page, OOS still show
  on later pages before their reordered siblings.

  Re-applies after the theme's facets.js replaces #ProductGridContainer.innerHTML
  on filter/sort changes.
*/
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-collection')) return;

  var GRID_ID = 'product-grid';
  var CONTAINER_ID = 'ProductGridContainer';
  var SOLDOUT_SELECTOR = '.product-card--soldout';
  var DONE_FLAG = 'aroOosLastApplied';

  function reorderGrid(grid) {
    if (!grid || grid.dataset[DONE_FLAG] === '1') return;

    var soldOutLis = [];
    var children = grid.children;
    for (var i = 0; i < children.length; i++) {
      var li = children[i];
      if (li.tagName !== 'LI') continue;
      // Skip the sticky loading-overlay <li> — theme uses it for facet loading state.
      if (li.classList.contains('loading-overlay')) continue;
      if (li.querySelector(SOLDOUT_SELECTOR)) soldOutLis.push(li);
    }

    if (soldOutLis.length === 0) {
      grid.dataset[DONE_FLAG] = '1';
      return;
    }

    // Move OOS <li>s to the end, but keep them before .loading-overlay so
    // the overlay stays at the very end of the grid where the theme expects it.
    var loadingOverlay = grid.querySelector(':scope > .loading-overlay');
    for (var j = 0; j < soldOutLis.length; j++) {
      if (loadingOverlay) {
        grid.insertBefore(soldOutLis[j], loadingOverlay);
      } else {
        grid.appendChild(soldOutLis[j]);
      }
    }
    grid.dataset[DONE_FLAG] = '1';
  }

  function apply() {
    var grid = document.getElementById(GRID_ID);
    if (grid) reorderGrid(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // facets.js replaces ProductGridContainer.innerHTML on filter/sort/pagination
  // clicks — that swaps the <ul id="product-grid"> for a fresh one. Observe the
  // container's direct childList so we catch the swap without noise from lazy
  // image mutations deep in the tree.
  var container = document.getElementById(CONTAINER_ID);
  if (container && 'MutationObserver' in window) {
    var observer = new MutationObserver(apply);
    observer.observe(container, { childList: true });
  }
})();
